<app-header (toggleSidenav)="sidenav.toggle()" (hideSidenav)="onLoggedOut(sidenav)" (loggedIn)="onLoggedIn(sidenav)"></app-header>
<mat-sidenav-container autosize id="mat-cont">
  <mat-sidenav #sidenav [mode]="isCompact ? 'over' : 'side'" style="height: 99%;">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content #sidenavContent>
    <router-outlet></router-outlet>
    <!-- <app-footer></app-footer> -->
  </mat-sidenav-content>
</mat-sidenav-container>
